const formStructure = [
  { name: 'id', label: 'ID', type: 'text', disabled: true },
  { name: 'needsReview', label: 'Tarkistettava', type: 'checkbox', disabled: false },
  { name: 'inUse', label: 'Aktiivinen', type: 'checkbox', disabled: false },
  {
    name: 'assertionId',
    label: 'Väitteen ID',
    type: 'text',
    disabled: true,
    validation: {
      required: { enabled: true, errorKey: 'validation_assertion_id_required' },
    },
  },
  { name: 'isAssertionTruthy', label: 'Väite tosi', type: 'checkbox', disabled: true },
  {
    name: 'imageType',
    label: 'Kuvan tyyppi',
    type: 'text',
    disabled: true,
  },
  {
    name: 'imageId',
    label: 'Kuvan ID',
    type: 'text',
    disabled: true,
    validation: {
      required: { enabled: true, errorKey: 'validation_image_id_required' },
    },
  },
  { name: 'descriptionId1', label: 'Kuvaus 1 ID', type: 'text', disabled: true },
  { name: 'descriptionId2', label: 'Kuvaus 2 ID', type: 'text', disabled: true },
  { name: 'descriptionId3', label: 'Kuvaus 3 ID', type: 'text', disabled: true },
  { name: 'categoryM', label: 'AM120', type: 'checkbox', disabled: false, group: 'category' },
  { name: 'categoryAM', label: 'AM121', type: 'checkbox', disabled: false, group: 'category' },
  { name: 'categoryA', label: 'A', type: 'checkbox', disabled: false, group: 'category' },
  { name: 'categoryB', label: 'B', type: 'checkbox', disabled: false, group: 'category' },
  { name: 'categoryBE', label: 'BE', type: 'checkbox', disabled: false, group: 'category' },
  { name: 'categoryC1', label: 'C1', type: 'checkbox', disabled: false, group: 'category' },
  { name: 'categoryC1E', label: 'C1E', type: 'checkbox', disabled: false, group: 'category' },
  { name: 'categoryC', label: 'C', type: 'checkbox', disabled: false, group: 'category' },
  { name: 'categoryCE', label: 'CE', type: 'checkbox', disabled: false, group: 'category' },
  { name: 'categoryD1', label: 'D1', type: 'checkbox', disabled: false, group: 'category' },
  { name: 'categoryD1E', label: 'D1E', type: 'checkbox', disabled: false, group: 'category' },
  { name: 'categoryD', label: 'D', type: 'checkbox', disabled: false, group: 'category' },
  { name: 'categoryDE', label: 'DE', type: 'checkbox', disabled: false, group: 'category' },
  { name: 'categoryT', label: 'T', type: 'checkbox', disabled: false, group: 'category' },
  { name: 'categoryTAXI', label: 'TAXI', type: 'checkbox', disabled: false, group: 'category' },
  { name: 'categoryCPC', label: 'AMP', type: 'checkbox', disabled: false, group: 'category' },
];

export const getImageFormFields = () => formStructure;

export const getDefaultImageFormData = () => {
  const defaultFormData = {};

  formStructure.forEach((field) => {
    defaultFormData[field.name] = field.type === 'checkbox' ? false : '';
  });

  return defaultFormData;
};

export const getImageFormData = (questionData) => {
  const newFormData = {};

  formStructure.forEach((field) => {
    const dynamicValue = questionData.image?.[field.name];
    const defaultValue = field.type === 'checkbox' ? false : '';
    newFormData[field.name] = dynamicValue ?? defaultValue;
  });

  return newFormData;
};

export const getImageRequestPayload = (formData) => {
  const payload = {
    image: {},
    id: formData.id,
  };

  formStructure.forEach((field) => {
    payload.image[field.name] = formData[field.name];
  });

  return payload;
};

export const validateImageFormData = (formData) => {
  const errors = {};

  formStructure.forEach((field) => {
    if (!field.validation) {
      return;
    }

    const value = formData[field.name];
    if (field.validation.required?.enabled) {
      if (!value || (typeof value === 'string' && value.trim() === '')) {
        errors[field.name] = field.validation.required.errorKey;
      }
    }
  });

  return {
    isValid: Object.keys(errors).length === 0,
    errors,
  };
};